import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields, DateTime } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { TabHeaderView } from "kea-react/dist/tabs/tabHeader";

type Entity = models.FiltroMovimientoCaja;

export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void> | void;
}
/**
* Valida un Entity
*/
export function validar(x: Entity) {
    const rules: validation.Rules<Entity> = {};
    return validation.getErrors(rules, x);
}

/**
* Componente para editar un Entity
*/

export class MovimientoCajaFiltroComponent extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));

    render() {

        //this.props.value.FechaCreacionInicio = new Date()
        
        const getField = this.getField;
        const DateSelect = getField(kea.DateTime);
    

        const { value } = this.props;
        return (
            <div>
                {kea.autogrid(3, [
                    <DateSelect field="FechaCreacionInicio" label="Fecha creación (inicio)" />,
                    <DateSelect field="FechaCreacionFinal" label="Fecha creación (final)" />,
                ])}
            </div>);
    }
}





// WEBPACK FOOTER //
// ./app/features/general/operativa/items/movimientoscaja/list/filtro.tsx